import {
	AAFieldPopperSX,
	AAFieldTooltipSX,
	AATooltipButtonSX,
} from '@/components/blocks/AddressForm/styles/fieldTooltip';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { IconButton, InputAdornment, Tooltip, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

type Props = {
	content: ReactNode;
};

export const FieldTooltip: FC<Props> = ({ content }) => {
	const theme = useTheme();

	return (
		<InputAdornment position="end">
			<Tooltip
				title={content}
				placement="bottom"
				slotProps={{
					tooltip: { sx: AAFieldTooltipSX },
					popper: {
						sx: AAFieldPopperSX,
					},
				}}
				sx={{ marginLeft: '5px' }}
				tabIndex={-1}
				enterTouchDelay={0}
				leaveTouchDelay={5000}
			>
				<IconButton disableRipple sx={AATooltipButtonSX}>
					<DynamicIcon
						name={MATERIAL_SYMBOL_ICONS.helpCenter}
						color={theme.palette.primary.main}
						variant="filled"
						size={14}
					/>
				</IconButton>
			</Tooltip>
		</InputAdornment>
	);
};
